import Callback from '@/services/Callback'
import To from 'await-to-js'
import qs from 'qs'
import { wizStandardInstance } from './instance'

export default class DataSourceService {
  // 列表
  static async list(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdDataQualityDataSource/GetList?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 新增
  static async add(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/StdDataQualityDataSource', payload)
    )
    return Callback(err, res)
  }
  // 更新
  static async update(payload) {
    const [err, res] = await To(
      wizStandardInstance.patch('/api/std/StdDataQualityDataSource', payload)
    )
    return Callback(err, res)
  }
  // 删除
  static async remove(payload) {
    const [err, res] = await To(
      wizStandardInstance.delete('/api/std/StdDataQualityDataSource', { data: payload })
    )
    return Callback(err, res)
  }
  // 获取质检源编码
  static async getCode(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdDataQualityDataSource/get_code?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 测试连接
  static async testConnect(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/StdDataQualityDataSource/test_connection?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
}
